import React, { useCallback, useEffect } from "react";
import parse from "html-react-parser";
import get from "lodash/get";
import { connect } from '../../store/connect';
import { getBookDataPaginatedResponse, getInitialData } from "../../store/actions/response.actions";
import { getBookManager } from "../../models/BookModel";
import { getTimespanId, hasAllowAllEvents } from "./booking-form.helpers";
import { toast } from "react-toastify";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import { useTranslation } from "react-i18next";
import { getBookDataResponseManager, isBookDataUpdated } from "../../models/BookModel/helpers";
var mapStateToProps = function (state, ownProps) {
    var _a;
    return {
        form: get(state.formReducer.forms, ownProps.name, {}),
        bookData: getBookDataPaginatedResponse(state.responseReducer),
        initialData: (_a = getInitialData(state.responseReducer)) === null || _a === void 0 ? void 0 : _a.response
    };
};
var mergeProps = function (_a) {
    var _b, _c;
    var initialData = _a.initialData, bookData = _a.bookData, form = _a.form;
    var options = initialData ? getResponseManager(initialData).options() : null;
    var entities = (_c = (_b = getBookDataResponseManager(bookData)) === null || _b === void 0 ? void 0 : _b.entities) !== null && _c !== void 0 ? _c : null;
    var ct = entities ? getBookManager(entities, options).courseTimespans() : null;
    var selectedTimespanId = getTimespanId(form);
    var selectedTimespan = ct === null || ct === void 0 ? void 0 : ct.findById(selectedTimespanId);
    return {
        id: selectedTimespanId,
        title: selectedTimespan === null || selectedTimespan === void 0 ? void 0 : selectedTimespan.getAsTitle([], {}),
        isFullyBooked: (hasAllowAllEvents(form) ? selectedTimespan === null || selectedTimespan === void 0 ? void 0 : selectedTimespan.get("max_bookable_places_left") : selectedTimespan === null || selectedTimespan === void 0 ? void 0 : selectedTimespan.quantityLeft) < 1
    };
};
export var TimespanIsFullyBooked = connect(mapStateToProps, null, mergeProps, isBookDataUpdated("bookData"))(function (props) {
    var id = props.id, title = props.title, isFullyBooked = props.isFullyBooked;
    var t = useTranslation().t;
    var FullyBookedTimespan = useCallback(function () {
        return React.createElement(React.Fragment, null, parse(t("bookcart.timespan_booked_out_msg", { title: props.title })));
    }, [title, isFullyBooked]);
    useEffect(function () {
        if (!isFullyBooked)
            return;
        toast.error(React.createElement(FullyBookedTimespan, null), { toastId: "fully-booked-" + props.id });
    }, [id, isFullyBooked, FullyBookedTimespan]);
    return null;
});
